export class User {
    Username: string;
    Password: string;
    ConfirmPassword: string;
    GrantType: string;
    Email: string;
    OTP: any = '';
}
